<template>
  <v-chip
    color="success"
    class="font-weight-medium"
    :class="classes"
    :ripple="!complete"
    @click.native.stop
    @click="onClick"
  >
    <v-icon v-if="complete" class="mr-1" size="20">check</v-icon>
    <span v-else class="mx-2">Confirm</span>
    <researcher-avatar-cluster
      :researchers="researchers"
      :disable-popover="!complete"
      small
    />
  </v-chip>
</template>

<script>
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';

export default {
  name: 'ConfirmConsensusChip',
  components: {
    ResearcherAvatarCluster,
  },
  props: {
    researchers: {
      type: Array,
      default: () => [],
    },
    complete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'elevation-2': !this.complete,
      };
    },
  },
  methods: {
    onClick() {
      if (!this.complete) {
        this.$emit('click');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
